import { Button, Icon } from "semantic-ui-react"
import styles from './ClubPage.module.css';

const onWhatsupClick = (text: string) => {
    let path = `https://wa.me/994512515100?text=${text.replace(' ', '%20')}`;
    window.location.href = path;
}
const Member = () => {
    return <section className={styles.priceTable}>
        <header className={styles.priceTable__header}>
            <h1 className={styles.priceTable__title}>Member</h1>
        </header>
        <table width={300} className={styles.priceTable__table}>
            <tbody>
                <tr>
                    <td>мероприятия<br />(1 напиток включён)</td>
                    <td className={styles.priceRight}>12 AZN</td>
                </tr>
                <tr>
                    <td>гастрономический тур<br /> 1 раз в год</td>
                    <td className={styles.priceRight}>бесплатно</td>
                </tr>
                <tr>
                    <td>онлайн-семинары</td>
                    <td className={styles.priceRight}>бесплатно</td>
                </tr>
                <tr>
                    <td>участие в аукционах</td>
                    <td className={styles.priceRight}>бесплатно</td>
                </tr>
                <tr><td className={styles.biginfo} colSpan={2}><span className={styles.price}>59 </span></td></tr>
                {/* {(!showForm) && <tr><td className={styles.biginfo} colSpan={2}>
                                            <Button onClick={onShowFormClick} type='button' color='google plus' icon labelPosition='left' size='small'>
                                                <Icon name='search plus' />
                                                заказать тур
                                            </Button>
                                        </td></tr>} */}
                <tr><td className={styles.biginfo} colSpan={2}>
                    <Button onClick={x => onWhatsupClick(`Cтать членом клуба - "Member"`)} type='button' color='green' icon labelPosition='left' size='small'>
                        <Icon name='whatsapp' />
                        Cтань членом клуба
                    </Button>
                </td></tr>
            </tbody>
        </table>
    </section>


}

export default Member